/* eslint-disable */
export default {
  unknown: 'Unbekannt',
  anonymous: 'Anonym',
  activeCall: 'Aktiver Anruf',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
